// extracted by mini-css-extract-plugin
export default {"changeShopButton":"click-and-collect-selected-point_changeShopButton__86942"};